export const waitForLaunchDarkly = () => {
	return new Promise((resolve, reject) => {
		if (!window.ldClient) {
			document.addEventListener('LDClientReady', resolve, { once: true });
		} else {
			window.ldClient.waitUntilReady().then(resolve).catch(reject);
		}
	});
};
